import { Skeleton } from '@/components/ui'
import { Page } from '@/layouts/page'

export const DetalhesEmpreendimentoPageSkeleton = () => {
  return (
    <div data-testid="detalhes-empreendimento-skeleton">
      <Page.Main>
        <Page.Header>
          <Page.Title>
            <Skeleton className="h-7 w-96" />
          </Page.Title>
        </Page.Header>
        <Page.Section className="space-y-12">
          <div className="space-y-4">
            <Skeleton className="h-6 w-32" />
            <div className="grid grid-cols-3 gap-6">
              <Skeleton className="h-17.5 w-full" />
              <Skeleton className="h-17.5 w-full" />
              <Skeleton className="h-17.5 w-full" />
            </div>
          </div>
          <div className="space-y-4">
            <Skeleton className="h-6 w-24" />
            <Skeleton className="h-9 w-full" />
            <div className="space-y-2">
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-3/4" />
            </div>
          </div>
          <div className="space-y-4">
            <Skeleton className="h-6 w-32" />
            <Skeleton className="h-4 w-1/2" />
          </div>
          <Skeleton className="h-20.5 w-full rounded-sm" />
        </Page.Section>
      </Page.Main>
    </div>
  )
}
